'use client';

import { TThemeColorScheme } from '@northladder/services';
import {
  saveLocalData,
  checkIfIsBrowserWindow,
  loadLocalData,
} from '@northladder/utilities';

import {
  APP_THEME_STORE_STORAGE_KEY,
  IThemeType,
  TInitialThemeState,
  TSetThemeState,
} from './types';

/**
 * This persists the session information to secure local storage.
 */
export const persistThemeStore = (targetState: TInitialThemeState) => {
  saveLocalData(APP_THEME_STORE_STORAGE_KEY, targetState);
};

export function loadAppThemeStore() {
  if (!checkIfIsBrowserWindow()) {
    return null;
  }

  return loadLocalData<IThemeType>(APP_THEME_STORE_STORAGE_KEY);
}

/**
 * This updates the color scheme in both local & app memory.
 */
export function updateColorSchemeCallback(set: TSetThemeState) {
  return function setColorScheme(colorScheme: TThemeColorScheme) {
    set(() => {
      persistThemeStore({ colorScheme });

      return { colorScheme };
    });
  };
}
